import {connect} from "react-redux";
import nav_logo from "../../images/dZen_3.png";

const Nav_Logo = (props) => {
    return(
        <div className={`nav_logo_div background_change_hover background_change_hover_${props.color_background}`}>
            <img className="nav_logo" src={nav_logo} alt="nav_logo" />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background
    }
}
export default connect(mapStateToProps)(Nav_Logo);